<template>
  <div class="homepage">
    <myheadBlock></myheadBlock>　
    <div class="shopbox">


      
      <div class="shoplist1" v-for="item2 in brandList" :key="item2.id">
        <div class="shoptitlebox">
            <p>康复课程</p>
          <!-- <img :src="item2.brandLogo" /> -->
        </div>
        <swiper :options="swiperOption" ref="mySwiper" class="shopswiper">
          <swiper-slide v-for="item in courseList" :key="item.id"> <a href="javascript:void(0)" @click="gotoShopDes(item.workoutImage)">
            <div class="swiperitemimg">
             
                <img :src="item.workoutImage" />
                <!-- <img src="~assets/images/club/tech.jpg" /> -->
            </div>
            <div class="shopitemdes">
              <p>{{ item.workoutName }}</p>
              <!-- <p class="shopitemdesp">{{item.typeCode}}</p> -->
              <p>￥{{ item.price }}元</p>
            </div>
             </a>
          </swiper-slide>

          <div class="swiper-scrollbar" slot="scrollbar"></div>
        </swiper>
      </div>


    </div>
    <div class="coursedesbox" v-if="showCourseDes" @click="closeCoursedesbox">
        <div class="coursedesimg">
            <img :src="showimage" />
        </div>
       
        
    </div>
    　
    <footerBlock></footerBlock>
  </div>
</template>

<script>
import footerBlock from "./../components/block/footer";
import myheadBlock from "./../components/block/myhead";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import axios from "axios"; // 导入 Axios

export default {
  name: "courselist",
  data() {
    return {
      shopid: "",
      msg: "",
      brandList: [],
      shopitemlist: {},
      courseList:[], 
      showimage:"",

      showCourseDes: false,

      swiperOption: {
        scrollbar: ".swiper-scrollbar",
        scrollbarHide: false,
        spaceBetween: 30,
        grabCursor: true,
        width: window.innerWidth * 0.8,
        slidesPerView: 3,
        onSlideChangeEnd: (swiper) => {
          this.page = swiper.realIndex + 1;
          this.index = swiper.realIndex;
        },
      },
    };
  },
  components: {
    footerBlock,
    myheadBlock,
  },
  computed: {
    
  },
  methods: {
    gotoShopDes: function (imageUrl) {
      console.log(imageUrl);
      this.showimage=imageUrl;
      this.showCourseDes = true;
    //   this.$router.push({
    //     name: "shopdes",
    //     params: {
    //       id: id,
    //     },
    //   });
    },
    closeCoursedesbox: function () {
      this.showCourseDes = false;
    },
    async CheckBandList() {
      // console.log(this.token);
      try {
        // 清空之前的响应和错误信息
        this.response = null;
        this.error = null;
        const params = {
          page: 1,
          size: 10,
        };

        const url =
          "https://ttserver.aizhuotice.online/api/v1/ttProd/page/brand";
        const response = await axios.get(url, {
          params: params,
          headers: {
            "Content-Type": "application/json",
            // token: this.token,
          },
        });

        // 处理成功响应
        this.response = response.data; // 将返回的数据存储到组件状态
        console.log(this.response.code);
        if (this.response.code == 200) {
          // console.log(this.response.data);
          this.brandList = this.response.data.data;

          console.log(this.brandList);
          this.brandList.forEach((element) => {
            
            this.CheckShopList(element.id);
          });
        } else {
        }
      } catch (err) {
        // 处理请求错误
        if (err.response) {
          // 服务器返回了错误响应（例如 4xx 或 5xx）
          this.error = `服务器错误: ${err.response.status} - ${err.response.statusText}`;
        } else if (err.request) {
          // 请求已发出，但没有收到响应
          this.error = "未收到服务器响应";
        } else {
          // 其他错误
          this.error = `请求失败: ${err.message}`;
        }
        console.log(this.error);
      }
    },

    async CheckShopList(bId) {
      // console.log(bId);
      try {
        // 清空之前的响应和错误信息
        this.response = null;
        this.error = null;
        const params = {
          page: 1,
          size: 10
        };

        const url = "https://ttserver.aizhuotice.online/api/v1/workout/page";
        const response = await axios.get(url, {
          params: params,
          headers: {
            "Content-Type": "application/json",
            token: this.token,
          },
        });

        // 处理成功响应
        this.response = response.data; // 将返回的数据存储到组件状态
        // console.log(this.response.code);
        if (this.response.code == 200) {
          console.log(this.response.data.data);
          // this.brandList = this.response.data.data;
          // const item1 = {
          //   bId: this.response.data.data,
          // };
          // const name=bId;
          // this.$set(this.shopitemlist, name, this.response.data.data);
          this.courseList=this.response.data.data;
          // this.courseList.push(this.response.data.data);
          // console.log(this.shopitemlist[name]);
          // this.shopitemlist.forEach((element) => {
          //  element.prodContent=element.prodContent.replace(/<img[^>]*>/g, "")
          // });
        } else {
        }
      } catch (err) {
        // 处理请求错误
        if (err.response) {
          // 服务器返回了错误响应（例如 4xx 或 5xx）
          this.error = `服务器错误: ${err.response.status} - ${err.response.statusText}`;
        } else if (err.request) {
          // 请求已发出，但没有收到响应
          this.error = "未收到服务器响应";
        } else {
          // 其他错误
          this.error = `请求失败: ${err.message}`;
        }
        console.log(this.error);
      }
    },
  },
  mounted() {
    this.CheckBandList();
    this.shopitemlist = {};
  },
  created() {},
};
</script>

<style scoped>
h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

.homepage {
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  height: auto;
  background-color: #181818;
}
.shopbox {
  width: 96vw;
  left: 2vw;
  height: auto;
  position: relative;
  background-color: #181818;
}

.shoplist1 {
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  height: 30vw;
  border-bottom: 6px solid #a82024;
}

.shoptitlebox {
  position: relative;
  top: 0.5vw;
  left: 0;
  width: 15vw;
  height: 5vw;
  overflow: hidden; /* 裁剪超出部分 */
  margin-bottom: 1vw;
  margin-top: 0.5vw;
}

.shoptitlebox img {
  width: 100%;
  height: 100%;
  object-fit: contain; /* 按比例缩放并裁剪 */
}
.shoptitlebox p{
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  text-align: center;
  line-height: 5vw;
  font-size: 2vw;
  color: #fff;
}
.shopswiper {
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  height: 25vw;
}

.swiperitemimg {
  width: 100%;
  height: 19vw;
}
.swiperitemimg img {
  width: 100%;
  height: 100%;
  object-fit: contain; /* 按比例缩放并裁剪 */
}
.shopitemdes {
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  text-align: center;
}
.shopitemdes p {
  font-size: 1.5vw;
  color: #fff;
  text-align: center;
  width: 100%;

}
.shopitemdes .shopitemdesp {
  margin-top: 0.5vw;
  margin-bottom: 0.5vw;
  font-size: 1.3vw;
  color: #8f8f8f;
  text-align: left;
  display: -webkit-box; /* 启用弹性盒子布局 */
  -webkit-line-clamp: 2; /* 显示最多 2 行 */
  -webkit-box-orient: vertical; /* 垂直方向布局 */
  overflow: hidden; /* 隐藏超出部分 */
  text-overflow: ellipsis; /* 超出部分显示省略号 */
}

.coursedesbox{
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 100;
}
.coursedesimg{
    position: relative;
    top: 10vh;
    left: 20%;
    width: 60%;
    height: 80vh;
}
.coursedesimg img{
    width: 100%;
    height: 100%;
    object-fit: contain;
}

</style>



// WEBPACK FOOTER //
// src/components/courselist.vue